<template lang="html">
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <div v-on="on" style="float: left;">
          <v-btn
          :color="color"
          icon
          text
          :disabled="disabled"
          @click="click()"
          >
            <v-icon dark>{{icon}}</v-icon>
          </v-btn>
        </div>
      </template>
      <span>
        <div v-if="disabled !== '' && !disabled">{{tooltip}}</div>
        <div v-else>{{disabledTooltip}}</div>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['icon', 'tooltip', 'disabled-tooltip', 'disabled', 'color'],
    data: () => ({
      focus: false,
      texto: ''
    }),
    computed: {
      couterRules: function (val) {
        let area = [
          (input) => (this.required === undefined) || !!input || 'Este campo é obrigatório',
          (input) => (input == null || input.length <= this.counter) || 'Este campo não pode possuir mais que ' + this.counter + ' caracteres'
        ]
        return area
      }
    },
    watch: {
      value: function (val) {
        this.texto = val
      }
    },
    methods: {
      setTexto () {
        console.log(!this.required)
        this.$emit('input', this.texto)
      },
      click () {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// c-tooltip-btn.vue?6ce56443